import React from 'react';
import ContactCard from 'components/atoms/card_contact';

const Contact: React.FC = () => {
  return (
    <div className="page-container">
      <ContactCard />
    </div>
  );
};
export { Contact };
